exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".request-submit-container .rs-title{color:#132056;font-size:22px;font-weight:600;line-height:29px}.request-submit-container .rs-subtitle{color:#5a6389;font-size:14px;font-weight:400;line-height:22px}.request-submit-container .rs-header{display:flex;flex-direction:column;text-align:center;align-items:center;gap:8px;margin-top:20vh}.request-submit-container .upgrade-footer{position:fixed;bottom:0;width:100%;padding:0 16px;background-color:#fff;max-width:var(--desktop-width)}.request-submit-container .upgrade-footer .upgrade-button{width:100%;margin-bottom:16px}", ""]);

// exports
